import { type Library } from '@air/api/types';
import { Skeleton } from '@air/component-skeleton';

import { useLibrary } from '~/components/LibraryBeta/hooks/queries/useLibrary';
import { LibraryDetailsAccessibilityPrivate } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/components/LibraryDetailsAccessibilityPrivate';
import { LibraryDetailsAccessibilityPublic } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/components/LibraryDetailsAccessibilityPublic';
import { LibraryDetails } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/LibraryDetails';

export type LibraryDetailsContainerProps = {
  libraryId: Library['id'];
};

export const LibraryDetailsContainer = ({ libraryId }: LibraryDetailsContainerProps) => {
  const { data: library, isLoading: isLibraryLoading } = useLibrary({ libraryId });

  // biome-ignore lint/suspicious/noUnnecessaryConditions: query isLoading is a runtime gate; the hook's types currently treat it as never loading.
  return isLibraryLoading ? (
    <LibraryDetails
      accessibility={
        <>
          <div className="flex items-center gap-1">
            <Skeleton height={16} width={16} />
            <Skeleton height={18} isText width={120} />
          </div>
          <Skeleton height={18} isText />
        </>
      }
      description={
        <>
          <Skeleton height={24} isText width="100%" />
          <Skeleton height={24} isText width="80%" />
        </>
      }
      title={<Skeleton height={24} isText />}
    />
  ) : (
    <LibraryDetails
      accessibility={
        library?.accessibility === 'private' ? (
          <LibraryDetailsAccessibilityPrivate />
        ) : (
          <LibraryDetailsAccessibilityPublic />
        )
      }
      description={
        library?.description ? (
          <p className="ads:text-secondary text-16 text-pigeon-600">{library.description}</p>
        ) : null
      }
      title={library?.title ? <div className="ads:text-secondary text-16 text-pigeon-600">{library.title}</div> : null}
    />
  );
};
